<div class="priceListLandingSubscription">
  <div class="nplLanding priceList-wrapper" style="width: 100%; margin:0;">
    <div class="priceListLandingPage  margin-0">
      <div class="topSection">
        <div class="alignTopSec">
          <div class="row padding-r15">
            <div class="col-10">
              <h5 class="text-left mt-2">Manage Sulfur & Zinc Sulfate Subscriptions</h5>
            </div>
            <div class="col-2 text-right m-auto">
              <a href="javascript:void(0)" routerLink="/cpp/report/sulfur-zinc-pricing">Close</a>
            </div>
          </div>

          <div class="form-sec">
            <div class="row padding-r15 padding-t15">
              <div class="col-3">
                <span>User Name: {{userName}}</span>
              </div>
              <div class="col-3">
                <span>Email Address: {{userEmailId}}</span>
              </div>
              <div class="col-3">
                <span>UserID: {{userId}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottomSection">
        <div class="row">
          <div class="col-md-12 productTableOuter">
            <div class="tableContainer priceListTable" id="cppOrderView">
              <table mat-table #placedCPPOrdersTable [dataSource]="plManageSubDataSource" multiTemplateDataRows class="matTables">
                <ng-container matColumnDef="reportName">
                  <th mat-header-cell *matHeaderCellDef class="text-left">Report Name</th>
                  <td mat-cell *matCellDef="let element"> {{element.reportName}} </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef class="text-center">Status</th>
                  <td mat-cell *matCellDef="let element">
                    <div class="order-info">
                      <a *ngIf="element.status == true" href="javascript:void(0)" (click)="addUpdateSubscription(false, element)" class="itemName subscribe">SUBSCRIBED</a>
                      <a *ngIf="element.status == false" href="javascript:void(0)" (click)="addUpdateSubscription(true, element)" class="itemName un-subscribe">UNSUBSCRIBED</a>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="updateUser">
                  <th mat-header-cell *matHeaderCellDef class="text-center">Last Modified By</th>
                  <td mat-cell *matCellDef="let element"> {{element.updateUser}} </td>
                </ng-container>
                <ng-container matColumnDef="updateTimestamp">
                  <th mat-header-cell *matHeaderCellDef class="text-center">Last Modified DateTime</th>
                  <td mat-cell *matCellDef="let element"> {{element.updateTimestamp}} </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="plManageSubColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let element; columns: plManageSubColumns"></tr>
              </table>
              <div *ngIf="plManageSubDataSource == undefined || plManageSubDataSource?.data.length == 0" class="noDataMsg">
                <p>No Data Found.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
